import * as Yup from 'yup'

// Ported 1:1 from src/pages/Settings/Locations/DetailV2/PaymentV2/schames.ts
export const paymentsSchema = Yup.object().shape({
  payments: Yup.object().shape({
    cash: Yup.object().shape({
      enabled: Yup.bool(),
      enabled_pickup: Yup.bool(),
      enabled_curbside: Yup.bool(),
      enabled_drive_through: Yup.bool(),
      enabled_delivery: Yup.bool(),
    }),
    credit_debit_card: Yup.object().shape({
      enabled: Yup.bool(),
      enabled_pickup: Yup.bool(),
      enabled_delivery: Yup.bool(),
      enabled_mail_order: Yup.bool(),
    }),
    interac_e_transfer: Yup.object().shape({
      enabled: Yup.bool(),
      enabled_pickup: Yup.bool(),
      enabled_delivery: Yup.bool(),
      enabled_mail_order: Yup.bool(),
      recipient_email: Yup.string()
        .email('Invalid email format')
        .when('enabled', {
          is: true,
          then: (schema) => schema.required('Please enter a Recipient Email'),
          otherwise: (schema) => schema.notRequired(),
        }),
      security_question: Yup.string().when('enabled', {
        is: true,
        then: (schema) => schema.required('Please enter a Security Question'),
        otherwise: (schema) => schema.notRequired(),
      }),
      security_answer: Yup.string().when('enabled', {
        is: true,
        then: (schema) => schema.required('Please enter a Security Answer'),
        otherwise: (schema) => schema.notRequired(),
      }),
    }),
  }),
})

export interface PaymentsFormValues {
  payments: {
    cash: {
      enabled: boolean
      enabled_pickup: boolean
      enabled_curbside: boolean
      enabled_drive_through: boolean
      enabled_delivery: boolean
      enabled_mail_order: boolean
    }
    credit_debit_card: {
      enabled: boolean
      enabled_pickup: boolean
      enabled_curbside: boolean
      enabled_drive_through: boolean
      enabled_delivery: boolean
      enabled_mail_order: boolean
    }
    interac_e_transfer: {
      enabled: boolean
      enabled_pickup: boolean
      enabled_curbside: boolean
      enabled_drive_through: boolean
      enabled_delivery: boolean
      enabled_mail_order: boolean
      recipient_email: string
      security_question: string
      security_answer: string
      additional_notes: string
      description: string
    }
  }
}
